module.exports = __webpack_public_path__ + "img/contactless-card.9ff01678.svg";